<template>
    <home endpoint="seatprice" :params="params"></home>
</template>

<script>
import home from '@/components/tools/Index'
export default {
  name: 'seatprice',
  components: {
    home,
  },
  data  () {
    return {
      params: {
        fields: [
          {name: 'id', hidden: 'true'},
          {name: 'ZoneCode', relation: 'seatzone', optionLabels: 'Name',
                editor: 'select', label: 'Zona', required: true, id: 'ZoneCode'},
          {name: 'MarketType', label: 'Mercado', editor: 'select', required: true, defValue: 0,
                options: [
                    {value: 0, label: 'Local'},
                    {value: 1, label: 'Internacional'},
                ]},
          {name: 'StartDate', label: 'Desde', required: true, editor: 'date'},
          {name: 'EndDate', label: 'Hasta', editor: 'date'},
          {name: 'Amount', label: 'Precio', editor: 'number', required: true},
          {name: 'CurrencyId', relation: 'currency', optionLabels: 'id',
                editor: 'select', label: 'Moneda', required: true, defValue: 'ARS'},
          {name: 'Closed', label: 'Cerrado', editor: 'checkbox'},
          ],
        title: 'Precios de Asientos',
        title2: 'Precio de Asiento',
      }
    }
  },
}
</script>
